import { EBAY, ETSY, FAIRE, SHOPIFY } from './channels';
import { FAIRE_INTEGRATION_ENABLED } from './features';

export const CHANNEL_DATA_KEYS = {
  [EBAY]: [
    'TAXONOMY',
  ],
  [ETSY]: [
    'SCALES_LOOKUP',
    'STANDARD_PROPERTIES',
    'SUGGESTED_OPTIONS_LOOKUP',
    'TAXONOMY',
    'TAXONOMY_SPECIFIC_PROPERTIES',
  ],
  [FAIRE]: [],
  [SHOPIFY]: [
    'COUNTRIES_LIST',
    'COUNTRIES_MAP',
    'TAXONOMY',
    'TAXONOMY_ATTRIBUTES',
    'TAXONOMY_ATTRIBUTE_VALUES',
  ],
};

if (FAIRE_INTEGRATION_ENABLED) {
  CHANNEL_DATA_KEYS[FAIRE].push(
    'TAXONOMY',
    'EXCHANGE_RATES',
  );
}
